<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-one-quarter">
            <b-menu>
              <b-menu-list :label="$t('compTransitionTransition1point5.data')">
                <b-menu-item
                  @click="activate('introduction')"
                  :active="activeModule === 'introduction'"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item">
                          <b-icon icon="info"></b-icon>
                          {{ $t('compTransitionTransition1point5.label-18') }}
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>

                <b-tooltip
                  :label="$t('compTransitionTransition1point5.tooltip-actions')"
                  type="is-black"
                  multilined
                  style="width: 100%"
                  :active="!allActionsActivated"
                >
                  <b-menu-item
                    @click="activate('all-actions')"
                    :active="activeModule === 'all-actions'"
                    :disabled="!allActionsActivated"
                  >
                    <template slot="label">
                      <nav class="level">
                        <div class="level-left">
                          <div class="level-item">
                            <b-icon icon="cog"></b-icon>
                            {{ $t('compTransitionTransition1point5.actions') }}
                          </div>
                        </div>
                      </nav>
                    </template>
                  </b-menu-item>
                </b-tooltip>
              </b-menu-list>

              <b-menu-list
                :label="$t('compTransitionTransition1point5.community')"
              >
                <b-tooltip
                  :label="
                    $t('compTransitionTransition1point5.tooltip-community')
                  "
                  type="is-black"
                  multilined
                  style="width: 100%"
                  :active="!(introduction.isValid || introduction.isAnonymous)"
                >
                  <b-menu-item
                    @click="activate('transition-maps')"
                    :active="activeModule === 'transition-maps'"
                    :disabled="
                      !(introduction.isValid || introduction.isAnonymous)
                    "
                  >
                    <template slot="label">
                      <nav class="level">
                        <div class="level-left">
                          <div class="level-item">
                            <b-icon icon="hubzilla"></b-icon>
                            {{
                              $t('compTransitionTransition1point5.community')
                            }}
                          </div>
                        </div>
                      </nav>
                    </template>
                  </b-menu-item>
                </b-tooltip>

                <b-menu-item
                  :active="activeModule === 'links'"
                  @click="activate('links')"
                >
                  <template slot="label">
                    <b-icon icon="external-link-square"></b-icon>
                    {{ $t('compTransitionTransition1point5.links') }}
                  </template>
                </b-menu-item>
              </b-menu-list>

              <b-menu-list label="Administration" v-if="hasReviewerPermissions">
                <b-menu-item
                  v-if="hasReviewerPermissions"
                  :active="activeModule === 'transition-review'"
                  @click="activate('transition-review')"
                >
                  <template slot="label">
                    <b-icon icon="check"></b-icon>
                    {{ $t('compTransitionTransition1point5.moderation') }}
                  </template>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
          <div class="column">
            <serveur-info :erreur="erreur" />
            <introduction
              :module="introduction"
              @is-valid="introIsValid"
              @is-anonymous="introIsAnonymous"
              :hasLab="hasLab"
              :hasSubmittedGHGIs="hasSubmittedGHGIs"
              v-if="activeModule === 'introduction'"
            />
            <charter v-if="activeModule === 'charter'" />
            <manual v-if="activeModule === 'manual'" />
            <team v-if="activeModule === 'team'" />
            <thanks v-if="activeModule === 'thanks'" />

            <!-- list of public actions -->
            <all-actions v-if="activeModule === 'all-actions'" />

            <!-- public -->
            <transition-maps v-if="activeModule === 'transition-maps'" />

            <transition-review v-if="activeModule === 'transition-review'" />

            <links v-if="activeModule === 'links'" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Background } from '@/mixins/background.js'
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useTransitionStore } from '@/stores/transition.js'

export default {
  name: 'Transition1point5',
  mixins: [Background],
  data () {
    return {
      erreur: '',
      loaded: false,
      activeModule: 'introduction',
      entity: null,
      plan: null,
      quota: 0,
      maxQuota: 0
    }
  },
  components: {
    charter: () => import('@/components/transition/docs/Charter.vue'),
    manual: () => import('@/components/transition/docs/Manual.vue'),
    team: () => import('@/components/transition/docs/Team.vue'),
    thanks: () => import('@/components/transition/docs/Thanks.vue'),
    introduction: () => import('@/components/transition/Introduction.vue'),

    'all-actions': () => import('@/components/transition/actions/Main.vue'),
    'transition-maps': () => import('@/components/transition/maps/Main.vue'),
    'transition-review': () =>
      import('@/components/transition/reviewer/Main.vue'),

    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    links: () => import('@/components/admin/Links.vue')
  },
  computed: {
    named: function () {
      return this.$route.params.named
    },
    allActionsActivated () {
      return (
        this.introduction.isValid &&
        !this.introduction.isAnonymous &&
        this.isAuthenticated
      )
    },
    allPlansActivated () {
      return (
        this.introduction.isValid &&
        !this.introduction.isAnonymous &&
        this.isAuthenticated
      )
    },
    introduction () {
      return this.transitionStore.introduction
    },
    hasLab: function () {
      return this.entity != null
    },
    hasSubmittedGHGIs: function () {
      return this.transitionStore.hasSubmittedGHGIs
    },
    isAuthenticated: function () {
      return this.authStore.isAuthenticated
    },
    canSkipIntro: function () {
      return (
        this.authStore.isAuthenticated && this.hasLab && this.hasSubmittedGHGIs
      )
    },
    hasReviewerPermissions: function () {
      return this.transitionStore.isReviewer
    },
    canAddActions: function () {
      return this.transitionStore.canAddActions
    }
  },
  methods: {
    setActiveModule () {
      //  shortcut
      if (this.named !== undefined) {
        return this.named
      }
      if (this.isAuthenticated && this.introduction.isValid) {
        return 'all-actions'
      } else if (this.introduction.isAnonymous) {
        return 'transition-maps'
      }
      return 'introduction'
    },
    /**
     * The user agreed on the terms and is logged in
     */
    introIsValid: function () {
      this.transitionStore.introIsValid()
      this.activeModule = 'all-actions'
    },
    /**
     * The user is anonymous
     */
    introIsAnonymous: function () {
      this.transitionStore.introIsAnonymous()
      this.activeModule = 'transition-maps'
    },
    introNotValid: function () {
      this.transitionStore.introIsInvalid()
      this.activeModule = 'introduction'
    },
    tagType: function (isModified) {
      let tagType = 'is-success'
      if (isModified) {
        tagType = 'is-danger'
      }
      return tagType
    },
    activate: function (module) {
      this.activeModule = module
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    const transitionStore = useTransitionStore()
    return { adminStore, authStore, transitionStore }
  },
  mounted () {
    // shortcut if we've been already there before
    if (this.introduction.isValid || this.introduction.isAnonymous) {
      // further validations are made inside this setActiveModule
      this.activeModule = this.setActiveModule()
    } else {
      // check app access
      // are we a reviewer ?
      this.transitionStore.init()
      this.erreur = ''
      this.bgUI(async () => {
        // check the lab
        let entity = null
        try {
          entity = await this.adminStore.getEntity()
          this.entity = entity
        } catch (error) {
          this.introNotValid()
          return
        }
        if (!this.entity) {
          this.introNotValid()
          return
        }
        this.activeModule = this.setActiveModule()
      })
    }
  }
}
</script>

<style scoped>
.dropdown .dropdown-menu .has-link a,
a.dropdown-item,
button.dropdown-item {
  text-align: center;
}
</style>
